var QuestionnaireAnswerFormat = /* @__PURE__ */ ((QuestionnaireAnswerFormat2) => {
  QuestionnaireAnswerFormat2["CheckBoxList"] = "CHECK_BOX_LIST";
  QuestionnaireAnswerFormat2["CheckBoxListNone"] = "CHECK_BOX_LIST_NONE";
  QuestionnaireAnswerFormat2["Date"] = "DATE";
  QuestionnaireAnswerFormat2["Dropdown"] = "DROPDOWN";
  QuestionnaireAnswerFormat2["Height"] = "HEIGHT";
  QuestionnaireAnswerFormat2["MultiSelect"] = "MULTI_SELECT";
  QuestionnaireAnswerFormat2["Phone"] = "PHONE";
  QuestionnaireAnswerFormat2["RadioButton"] = "RADIO_BUTTON";
  QuestionnaireAnswerFormat2["TextArea"] = "TEXT_AREA";
  QuestionnaireAnswerFormat2["TextBox"] = "TEXT_BOX";
  QuestionnaireAnswerFormat2["Weight"] = "WEIGHT";
  return QuestionnaireAnswerFormat2;
})(QuestionnaireAnswerFormat || {});
export {
  QuestionnaireAnswerFormat
};
